import { getServiceName } from '@repo/utils';

import BubblechatRevenuePolicy from './bubblechat'; // bubblechat 전용
import TingleRevenuePolicy from './tingle'; // tingle 전용

const RevenuePolicy = () => {
  const serviceName = getServiceName();
  if (serviceName === 'tingle') return <TingleRevenuePolicy />;
  return <BubblechatRevenuePolicy />;
};

export default RevenuePolicy;
